
import { defineComponent, nextTick } from 'vue'
import { useStore } from 'vuex'
import ApiService from '@/services/ApiService'
import { AdmissibleInfos } from '@/types/layout'
import { Dossier } from '@/types/portal'
import { UserResponse } from '@/types/api-response'
import InfoTooltip from '@/components/elements/InfoTooltip.vue'

export default defineComponent({
  name: 'TextInput',
  components: { InfoTooltip },
  data () {
    return {
      infos: {} as {[key: string]: string},
      cvecNumber: '',
      isSubmitting: false,
      cvecErrors: {} as {[key: string]: string},
      dossiers: [] as Dossier[]
    }
  },
  mounted () {
    nextTick(() => {
      ApiService.get<Dossier[]>('/admissibles/portal/dossiers').then((response) => {
        this.dossiers = response.data
      })
    })
    window.setTimeout(() => {
      const input1 = document.getElementById('cvec_number_1') as HTMLInputElement | null
      const input2 = document.getElementById('cvec_number_2') as HTMLInputElement | null
      const input3 = document.getElementById('cvec_number_3') as HTMLInputElement | null

      if (!input1 || !input2 || !input3) {
        return
      }

      input1.addEventListener('paste', (e: ClipboardEvent) => {
        e.preventDefault()

        const paste = e.clipboardData?.getData('text') || ''
        const cleaned = paste.replace(' ', '').replace(/\s/g, '').trim()

        input1.value = cleaned.slice(0, 4)
        input2.value = cleaned.slice(4, 10)
        input3.value = cleaned.slice(10, 12)

        this.cvecNumber = cleaned

        input3.focus() // focus last input
      })

      const inputs = [input1, input2, input3]

      inputs.forEach((input: HTMLInputElement, index: number) => {
        input.addEventListener('input', () => {
          if (input.value.length === input.maxLength && index < inputs.length - 1) {
            inputs[index + 1].focus()
          }
          this.cvecNumber = inputs.map(i => i.value).join('')
        })

        input.addEventListener('keydown', (e: KeyboardEvent) => {
          if (e.key === 'Backspace' && input.value.length === 0 && index > 0) {
            inputs[index - 1].focus()
          }
        })
      })
    }, 0)
  },
  computed: {
    admissibleInfos (): AdmissibleInfos {
      return useStore().getters.getAdmissibleInfos
    },
    user (): UserResponse {
      return useStore().getters.getUser
    },
    dossier (): Dossier {
      return useStore().getters.getDossier
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    useInfo: {
      type: Object,
      default: null
    }
  },
  methods: {
    submitCvec () {
      const yearInput = document.getElementById('cvec_year') as HTMLInputElement | null
      const mailInput = document.getElementById('cvec_mail') as HTMLInputElement | null
      const nameInput = document.getElementById('cvec_student_lastname') as HTMLInputElement | null
      const dossierInput = document.getElementById('cvec_student_dossier') as HTMLInputElement | null
      this.isSubmitting = true
      if (this.checkCvecNumber(yearInput?.value, this.cvecNumber)) {
        const requestData = {
          name: nameInput?.value,
          num_cvec: this.cvecNumber,
          year: yearInput?.value,
          mail: mailInput?.value,
          dossierId: dossierInput?.value
        } as {[key: string]: string}
        ApiService.post<{[key: string]: string}>('/cvec/process', requestData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          this.infos.success = 'La CVEC a bien été mie à jour.'
          this.cvecErrors = {}
          this.isSubmitting = false
          location.reload()
        }).catch(() => {
          this.cvecErrors.requestError = 'Une erreur est survenue.'
          this.isSubmitting = false
        }).finally(() => {
          this.isSubmitting = false
        })
      }
    },
    checkCvecNumber (year:string | undefined, number:string) {
      const yearChar = this.cvecNumber.charAt(3)
      const currYearChar = year?.toString().charAt(year?.toString().length - 1)
      if (number.length !== 12) {
        this.cvecErrors.cvecLength = 'Le numéro de CVEC doit contenir 12 caratère.'
        this.isSubmitting = false
        return false
      }
      if (yearChar !== currYearChar) {
        this.cvecErrors.cvecYear = 'Le numéro de CVEC fourni n\'est pas valable pour l\'année scolaire de votre inscription.'
        this.isSubmitting = false
        return false
      }
      this.cvecErrors = {}
      return true
    }
  }
})

